module.exports = __webpack_public_path__ + "static/react-f27817f4a349e9aebc4d019de68e3f8a.png";